
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { RecycleScroller } from "vue-virtual-scroller";

import Vue from 'vue'
import ListRow from './ListRow.vue'

export default Vue.extend({
    components: { RecycleScroller, ListRow },
    props: {
        listId: {
            type: String,
            default: ''
        },
        entries: {
            type: Array,
            default:() => []
        },
        allowSelection: {
            type: Boolean,
            default: false
        },
        selectedEntries: {
            type: Array,
            default: () => []
        },
        distanceTo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            // height: 1000,
        }
    },
    computed: {
        selectState() {
            // short cuts
            if(!this.selectedEntries.length) return false

            const seletedIds = this.selectedEntries.map((e: any) => e.id)
            let oneIncluded = false
            let allIncluded = true
            for(let e of <any[]>this.entries) {
                if(!seletedIds.includes(e.id)) allIncluded = false
                else oneIncluded = true
            }
            if(!oneIncluded) return false
            if(allIncluded) return true
            return null
        }
    },
    methods: {
        checkboxToggle() {
            const entryIds = this.entries.map((e: any) => e.id)
            const selected = this.selectedEntries.filter((s: any) => entryIds.includes(s.id))
            if(this.selectState === false) {
                this.$emit('entryToggle', this.entries)
            } else {
                this.$emit('entryToggle', selected)
            }
        }
    }
})
